import React from 'react'
import PropTypes from 'prop-types'
import IconLabel from './IconLabel'
import {CheckSquareFilled} from '@ant-design/icons'

const StylingProduct = ({product}) => {
  if (product.plus) {
    return (
      <div className="selected-product-options StylingProduct">
        <IconLabel icon={<CheckSquareFilled />} label="Interiørveiledning assistanse" />
      </div>
    )
  }

  return null
}

StylingProduct.propTypes = {
  product: PropTypes.object.isRequired,
}

export default StylingProduct
